// Static single-page site is served from public/index.html.
// The React bundle stays inert so its styles/scripts never touch the page.
const rootEl = document.getElementById("root");
if (rootEl) {
  import("./App");
}
